export default "__VITE_ASSET__Bg0H6_Gu__"